<template>
  <v-container>
    <div
      class="
        d-flex
        justify-content-center
        background
        text
        border
        pt-2
        pb-2
        mt-5
      "
    >
      <div style="width: 80%" class="text-center">
        <h3>Tibia Wallstreet</h3>
        <hr />
        <v-text-field
          v-model="username"
          label="Username"
          :rules="rules"
          hide-details="auto"
          dark
        ></v-text-field>
        <v-text-field
          v-model="password"
          class="mb-3"
          label="password"
          :rules="rules"
          hide-details="auto"
          type="password"
          dark
        ></v-text-field>
        <v-btn
          @click="loginPressed({ username: username, password: password })"
          class="mt-3 mb-3"
        >
          Login
        </v-btn>

        <div class="text-center">
          {{ loginResponse }}
        </div>
      </div>
    </div>
  </v-container>
</template>

<script>
import { mapMutations, mapState } from "vuex";
export default {
  data: () => ({
    username: "",
    password: "",
    rules: [
      (value) => !!value || "Required.",
      (value) => (value && value.length >= 3) || "Min 3 characters",
    ],
  }),
  methods: {
    ...mapMutations(["login"]),
    loginPressed(data) {
      this.login(data);
    },
  },
  computed: {
    ...mapState(["loginResponse"]),
  },
};
</script>

<style scoped>
.background {
  background-color: rgb(12, 25, 32);
}

.text {
  color: rgb(238, 195, 147);
}

.border {
  border-radius: 10px;
  border-width: 2px;
  border-color: white;
}
.hoverable:hover {
  cursor: pointer;
  background-color: rgb(60, 60, 60);
}
</style>